import { Button, Dialog, Portal, Text } from '@chakra-ui/react'
import { LuCloudAlert, LuRefreshCw } from 'react-icons/lu'

import { DialogAccent } from '@/components/ui/DialogAccent'
import { useSystemStore } from '@/stores/system.store'

export function BackendUnavailableOverlay() {
  const backendDown = useSystemStore(s => s.backendDown)
  const setBackendUp = useSystemStore(s => s.setBackendUp)

  return (
    <Dialog.Root
      open={backendDown}
      role="alertdialog"
      accented
      closeOnInteractOutside={false}
      onOpenChange={({ open }) => {
        if (!open) setBackendUp()
      }}
    >
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <DialogAccent icon={LuCloudAlert} colorPalette="red" />

            <Dialog.Header>
              <Dialog.Title>Verbindung vorübergehend nicht verfügbar</Dialog.Title>
            </Dialog.Header>

            <Dialog.Body>
              <Text>
                Das SIB-Portal kann derzeit keine Verbindung zu den zentralen Systemen herstellen.
                Vorgänge können deshalb momentan nicht verarbeitet werden. Bitte versuchen Sie es
                in wenigen Minuten erneut.
              </Text>
            </Dialog.Body>

            <Dialog.Footer>
              <Dialog.ActionTrigger asChild>
                <Button variant="outline" colorPalette="gray">
                  Schließen
                </Button>
              </Dialog.ActionTrigger>

              <Button
                variant="outline"
                colorPalette="gray"
                onClick={() => window.location.reload()}
              >
                <LuRefreshCw />
                Erneut versuchen
              </Button>
            </Dialog.Footer>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
